import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "aviana_cookies_accepted";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/settings");
        if (!data.show_cookie_banner) { setEnabled(false); return; }
      } catch {}
      const accepted = localStorage.getItem(KEY);
      if (!accepted) setShow(true);
    })();
  }, []);

  const accept = (level) => {
    localStorage.setItem(KEY, level);
    setShow(false);
  };

  if (!enabled || !show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[60] bg-aviana-cream rounded-2xl border border-aviana-border shadow-[0_24px_60px_-16px_rgba(31,20,36,0.35)] p-6 animate-fade-up" data-testid="cookie-banner">
      <p className="overline-plum mb-2">A small note</p>
      <p className="text-sm text-aviana-inkSoft leading-[1.65]">
        We use a few cookies to remember you, keep you signed in, and understand which offerings resonate.
        You can accept all, accept essentials only, or read our policy at any time.
      </p>
      <div className="mt-5 flex flex-wrap gap-2">
        <button onClick={() => accept("all")} className="btn-gold !py-2 !px-4 !text-[10px]" data-testid="cookies-accept">Accept all</button>
        <button onClick={() => accept("essentials")} className="btn-secondary !py-2 !px-4 !text-[10px]" data-testid="cookies-essentials">Essentials only</button>
      </div>
    </div>
  );
}
